// removed by extract-text-webpack-plugin
module.exports = {"tabWrapper":"_1xHF7PMd6_ixNdJg572CFn","photoWrapper":"_2TCXAeFtxNeJfubfv41pV3","textWrapper":"_3uQG-HDrI79rXVLSFskMLN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabVirtualTour/TabVirtualTour.scss
// module id = 1800
// module chunks = 0